// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8007":"14bd5fb24a14e69e","9886":"e16baed9f1ded167"}[chunkId] + ".js";
};